import React from 'react'
import { cn } from '../../utils/cn'

interface Props {
  className?: string
}

const IconCard = ({ className }: Props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='50'
      height='50'
      viewBox='0 0 50 50'
      fill='none'
    >
      <path
        d='M39.8438 9.375H10.1562C7.13594 9.375 4.6875 11.8234 4.6875 14.8438V35.1562C4.6875 38.1766 7.13594 40.625 10.1562 40.625H39.8438C42.8641 40.625 45.3125 38.1766 45.3125 35.1562V14.8438C45.3125 11.8234 42.8641 9.375 39.8438 9.375Z'
        strokeLinecap='round'
        strokeLinejoin='round'
        className={cn(
          'stroke-lightGray duration-300 transition-all',
          className,
        )}
      />
      <path
        d='M4.6875 18.75H45.3125M12.5 29.2969H17.1875V31.25H12.5V29.2969Z'
        strokeWidth='1.875'
        strokeLinejoin='round'
        className={cn(
          'stroke-lightGray duration-300 transition-all',
          className,
        )}
      />
    </svg>
  )
}

export default IconCard
